import { LegacyImage as Image } from '@/atoms/LegacyImage'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { TextOverlay } from './TextOverlay'

export const OurMissionSection = () => {
  return (
    <section className="bg-black">
      <div className="relative h-[300px] md:h-[800px]">
        <ResponsiveBackgroundImage
          src={getCloudinaryImageUrl({
            path: '/v1717627985/angel-app/assets/featured/Cabrini_2.png',
            transforms: 'q_auto:best,w_auto,c_fill',
          })}
        />
        <div className="absolute bottom-4 right-8 md:hidden">
          <Image
            alt="Cabrini Logo"
            src="/v1688337569/angel-app/Cabrini/branding/Cabrini_Temp_Logo_White.png"
            height="14"
            width="104"
          />
        </div>
        <div className="absolute bottom-16 right-16 hidden md:block xl:bottom-[90px] xl:right-[90px]">
          <Image
            alt="Cabrini Logo"
            src="/v1688337569/angel-app/Cabrini/branding/Cabrini_Temp_Logo_White.png"
            height="24"
            width="178"
          />
        </div>
        <TextOverlay className="absolute left-[166px] top-1/2 hidden max-w-[455px] -translate-y-1/2 md:block xl:left-[186px] xl:max-w-[760px]" />
      </div>
      <TextOverlay className="px-8 pt-[60px] md:hidden" />
    </section>
  )
}
